import CompanyQuoteResearch from './CompanyQuoteResearch'
// Uncomment the below to migrate to stateful component
// import CompanyQuoteResearchContainer from './CompanyQuoteResearchContainer'

export { CompanyQuoteResearch }
export default CompanyQuoteResearch
// Uncomment the below to migrate to stateful component
// export { CompanyQuoteResearchContainer }
// export default { CompanyQuoteResearchContainer }
